import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.scss"
import Topbar from "./components/Topbar";
import Background from "./components/visuals/Background";
import JournalEntriesPage from "./pages/JournalEntriesPage";
import CreateEntryPage from "./pages/CreateEntryPage";
import JournalEntryDetail from "./pages/JournalEntryDetail";
import Homepage from "./pages/Homepage";
import NotFound from "./pages/NotFound";
import BonfireStatistics from "./pages/BonfireStatistics";
import Footer from "./components/Footer";

const App : React.FC = () => {
    return (
        <>
            <Background />
            <Topbar />
            <Routes>
                <Route path="/" element={<Homepage />} />
                <Route path="/entries/browse" element={<JournalEntriesPage />} />
                <Route path="/entries/new" element={<CreateEntryPage />} />
                <Route path="/entries/viewing" element={<JournalEntryDetail />} />
                <Route path="/entries/error" element={<NotFound
                    primaryMessage="It seems that the journal entry page you're looking for is not found. It might already got thrown into the bonfire."
                    secondaryMessage="Entries can't stay hanging here. We need to burn them eventually." />} />
                <Route path="/entries/rate-limited" element={<NotFound
                    statusCode={429}
                    primaryMessage="Hey! You've written many entries at once!"
                    secondaryMessage="Looks like you will need to fall back in line before you write something again!" />} />
                
                <Route path="/bonfire-statistics" element={<BonfireStatistics/>}/>

                {/* Display 404 page not found if no routes match the above */}
                <Route path="*" element={<NotFound
                    primaryMessage="Whoops. You tried to venture off to a route that leads to nowhere and therefore does not exist!"
                    secondaryMessage="Double check your URL. Perhaps somebody gave you the wrong directions! " />} />
            </Routes>
            <Footer title="open journal bonfire" slogan="Share the greatest moments. Or dish everything out to the bonfire!"/>
        </>
    );
};

export default App;